import isMessageListBranchExpansionType from "owa-mail-organization-settings/lib/utils/isMessageListBranchExpansionType";
import MailListItemSelectionSource from "owa-mail-store/lib/store/schema/MailListItemSelectionSource";
import { getListViewState } from "owa-mail-list-store";
import { isFirstLevelExpanded } from "owa-mail-list-store/lib/selectors/isConversationExpanded";
import resetExpansionViewStateInternal from "owa-mail-list-store/lib/utils/resetExpansionViewStateInternal";

export default function setExpansionStoreState(rowKey: string, mailListItemSelectionSource: MailListItemSelectionSource): void {
    const expansionState = getListViewState().expandedConversationViewState;
    if (expansionState.expandedRowKey != rowKey) {
        // Collapsed state
        if (isMessageListBranchExpansionType()) {
            // Set to loading 1st level
            expansionState.shouldBeExpanded = true;
            expansionState.expandedRowKey = rowKey;
            // Skip resetting already-empty observable arrays to avoid triggering unnecessary MobX reactions
            if (!expansionState.forks || expansionState.forks.length > 0) {
                expansionState.forks = [];
            }
        }
        else if (mailListItemSelectionSource === MailListItemSelectionSource.MailListItemTwisty) {
            // set to loading second level
            expansionState.shouldBeExpanded = true;
            expansionState.expandedRowKey = rowKey;
            expansionState.forks = null;
        }
    }
    else {
        // set loading second level if currently first level is expanded and twisty is clicked.
        if (mailListItemSelectionSource === MailListItemSelectionSource.MailListItemTwisty &&
            isFirstLevelExpanded(rowKey)) {
            const previousSelectedForkId = expansionState.selectedNodeIds?.[0];
            resetExpansionViewStateInternal();
            expansionState.shouldBeExpanded = true;
            expansionState.expandedRowKey = rowKey;
            // Preserve the previously selected fork id so that the same item is initially selected after the full expansion
            if (previousSelectedForkId) {
                expansionState.selectedNodeIds = [previousSelectedForkId];
            }
        }
    }
}
